import React, { useState } from 'react';

import Footer from '../components/Footer';
import Navbar from '../components/Navbar';



import image01 from '../assets/CardsImages/card-3-img/img_31.jpg'
import image02 from '../assets/CardsImages/card-3-img/img_32.jpg'
import image03 from '../assets/CardsImages/card-3-img/img_33.jpg'
import image04 from '../assets/CardsImages/card-3-img/img_34.jpg'
import image05 from '../assets/CardsImages/card-3-img/img_32.jpg'
import image06 from '../assets/CardsImages/card-3-img/img_36.jpg'
import image07 from '../assets/CardsImages/card-3-img/img_37.jpg'
import image08 from '../assets/CardsImages/card-3-img/img_38.jpg'
import image09 from '../assets/CardsImages/card-3-img/img_39.jpg'
import image10 from '../assets/CardsImages/card-3-img/img_40.jpg'
import image11 from '../assets/CardsImages/card-3-img/img_41.jpg'
import image12 from '../assets/CardsImages/card-3-img/img_42.jpg'
import image13 from '../assets/CardsImages/card-3-img/img_43.jpg'
import image14 from '../assets/CardsImages/card-3-img/img_44.jpg'
import image15 from '../assets/CardsImages/card-3-img/img_45.jpg'
import image16 from '../assets/CardsImages/card-3-img/img_31.jpg'



const Card03 = () => {


  const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

  const images = [
    image01,
    image02,
    image03,
    image04,
    image05,
    image06,
    image07,
    image08,
    image09,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16


    // Add the rest of the images here...
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image); // Set the selected image
  };

  const handleClose = () => {
    setSelectedImage(null); // Clear the selected image
  };


  return (

    <div>
      {/* <Navbar /> */}
      <div className="container mx-auto px-6 py-12 mt-8">
        <h1 className="text-3xl font-bold text-center text-purple-950 mb-8">Distillation Column Supervision</h1>
        <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">
          <h2 className="text-2xl font-semibold mb-4">Distillation Column Supervision & Inspection Job</h2>
          <p className="mb-4">
            Distillation column supervision and inspection jobs involve overseeing the operation of a distillation column,
            ensuring it performs efficiently, and conducting routine inspections to identify any issues that may require
            maintenance or repairs.
          </p>
          <p className="mb-4">
            Distillation column supervision and inspection jobs are crucial to maintain the reliability, safety, and
            performance of these critical components in various industrial processes.
          </p>
        </div>

        <div className="container mx-auto px-4 py-8 my-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">1. Supervision of Operation</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Monitor the day-to-day operation of the distillation column, ensuring it runs within specified parameters.</li>
                  <li>Oversee the control systems, process variables, and safety measures to maintain safe and efficient operation.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Process Optimization</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Continuously assess and optimize the distillation process to maximize product yield, quality, and energy efficiency.</li>
                  <li>Adjust operating parameters, such as reflux ratio, feed rates, and tray or packing pressures, to achieve desired separation objectives.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">3. Routine Inspections</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Conduct routine visual inspections of the distillation column and its associated equipment.</li>
                  <li>Look for signs of leaks, corrosion, wear, or damage to the column's external surfaces and internals.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">4. Safety Compliance</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Ensure that all safety protocols and procedures are followed during the operation of the distillation column.</li>
                  <li>Implement and maintain safety measures to protect personnel and the environment.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">5. Documentation</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Maintain thorough records of process data, inspection findings, maintenance activities, and safety reports.</li>
                  <li>Keep records of equipment maintenance schedules and inspections to ensure compliance with regulatory requirements.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">6. Continuous Improvement</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Suggest and implement improvements in distillation column operation and equipment to enhance efficiency and reliability.</li>
                  <li>Keep up to date with the latest industry best practices and technologies.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">7. Emergency Response</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Be prepared to respond to emergencies, such as process upsets, equipment failures, or safety incidents.</li>
                </ul>
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-purple-800 mb-4">8. Training and Skill Development</h2>
              <p className="text-gray-700">
                <ul className="list-disc pl-5">
                  <li>Stay current with the latest advancements in distillation technology and safety procedures.</li>
                  <li>Provide training and guidance to operators and technicians as necessary.</li>
                </ul>
              </p>
            </div>
          </div>
        </div>

        {/* All Work Section */}
        <div className="my-12 text-center">
          <h2 className="text-2xl font-semibold text-purple-900 mb-4">All Work</h2>
          <p className="text-lg text-gray-700 mb-4">We provide high standard work for your Company solutions</p>
        </div>

        {/* Images Section */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              onClick={() => handleImageClick(image)} // Set the image on click
            >
              <img
                src={image}
                alt={`Gallery Image ${index + 1}`}
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
              />
            </div>
          ))}
        </div>


        {/* Modal to show selected image */}
        {selectedImage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
            <div className="relative">
              <img
                src={selectedImage}
                alt="Selected"
                className="max-w-full max-h-screen rounded-lg"
              />
              <button
                onClick={handleClose}
                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
              >
                ✖
              </button>
            </div>
          </div>
        )}
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default Card03;
